import {Component, OnInit} from '@angular/core';
import {TermModel} from '../../../../DataModels/term-model';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DataService} from '../../../../Services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {NotificationService} from '../../../../Services/notification.service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {Title} from '@angular/platform-browser';
import {TaxRateModel} from '../../../../DataModels/tax-rate-model';
import {NavigationService} from '../../../../Services/navigation.service';

@Component({
  selector: 'app-term-form',
  templateUrl: './term-form.component.html',
  styleUrls: ['./term-form.component.css'],
  standalone: false
})
export class TermFormComponent implements OnInit {


  termID;
  term: TermModel;
  termForm: UntypedFormGroup;
  retMsg = '';
  submitted = false;
  message = '';
  isSaveNew = false;
  originalSnapshot: any = {};

  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };

  constructor(private table: DataService,
              private notification: NotificationService,
              private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private confirmDialogService: ConfirmDialogService,
              private titleService: Title,
              private nav: NavigationService) {
    this.createForm();
    this.termID = this.route.snapshot.params.id;
  }

  // easy way to access form ctrls
  get f() {
    return this.termForm.controls;
  }

  createForm() {
    this.termForm = this.formBuilder.group({
      code: ['', Validators.required],
      name: ['', Validators.required],
      discount_days: ['0'],
      discount_percent: ['0'],
      due_days: ['', Validators.required],
      active: [true]
    });
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:Terms@@terms:Terms`);
    if (this.termID) {
      this.LoadData();
      this.buttonConfig.reset = false;
    } else {
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }
  }

  LoadData() {
    this.table.getData('term', this.termID).subscribe(
      result => {
        this.term = result;
        // console.log('loadcalled');
      },
      (error: HttpErrorResponse) => {
        this.notification.error($localize`:Error loading Term @@errorloadingTerm:Error loading Term`);
        console.log(error);
      },
      () => {
        this.termForm.patchValue(this.term);
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
  }

  resetForm() {
    this.termForm.reset();
    this.submitted = false;
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  private resetToDefaults(): void {
    // Reset form to known defaults and prepare component for a fresh new entry
    this.termForm.reset({
      code: '',
      name: '',
      discount_days: '0',
      discount_percent: '0',
      due_days: '',
      active: false
    });
    this.termID = null;
    this.submitted = false;
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  onClose() {
    const fallback = '/admin/term-list';
    this.nav.backOr(fallback);
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [$localize`:Are you sure you want to delete account? @@areYouSureYouWantToDeleteThisTerm:Are you sure you want to delete this Term?`, this.term.name + ' : ' + this.term.code];
    this.confirmDialogService.confirmThis(messages,
      () => {
        this.table.deleteDataById('term', this.termID).subscribe(
          result => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.onClose();
          });
      }, () => {
        this.notification.success($localize`:Delete Canceled@@deleteCanceled:Delete Canceled`);
      });
  }

  saveClose() {
    this.onSave(true);
  }

  saveNew() {
    // Clear the form only for Save & New, after async POST/PATCH succeeds
    this.isSaveNew = true;
    this.onSave(false);
  }

  onSave(saveClose: boolean) {
    this.submitted = true;
    if (this.termForm.invalid) {
      this.notification.error($localize`:Form Errors! @@formErrors:Form Errors!`);
      return;
    }
    this.term = Object.assign({}, this.termForm.value);
    if (this.termID) {
      this.table.patch('term', this.termID, this.term).then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
        if (saveClose) {
          this.onClose();
        } else if (this.isSaveNew) {
          this.resetToDefaults();
          this.isSaveNew = false;
        }
      });
      } else {
        this.table.postWithPromise('term', this.term).then(res => {
          // stops double posting when clicking Save
          let apiReturn: any = null;
          if (typeof res === 'object') {
            apiReturn = JSON.parse(JSON.stringify(res));
          }
          this.termID = apiReturn.id;
          try {
            this.originalSnapshot = this.buildSnapshot();
          } catch {
          }
          if (saveClose) {
            this.onClose();
          } else if (this.isSaveNew) {
            this.resetToDefaults();
            this.isSaveNew = false;
          }
        });
      }
    this.submitted = false;
    return true;
  }

  buildSnapshot(): any {
    try {
      return this.termForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }
}
